import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  /*
   * No `flex: 1`.
   *
   * This card sits in the left column of a two-column grid whose row height is set by the
   * TALLER right column (Status + PromotionSummary + BillingSummary). The column is a flex
   * column stretched to that height, so `flex: 1` here made this card absorb all the
   * leftover space — leaving a large empty area inside its own border, between the booking
   * information and the booker details below it. An operator marked exactly that region and
   * reported it as white space taking up too much room.
   *
   * Without it the card is its natural height and the slack falls to the bottom of the
   * column, below the last card, where there is no border to draw attention to it.
   *
   * The other consumer (BookingDetailsModify) renders this as a GRID item (its `root` is
   * `display: grid`), and a grid item ignores flex-sizing, so `flex: 1` was inert there too.
   */
  root: {
    borderRadius: 8,
    margin: '8px 0',
    border: `1px solid ${theme.palette.grey[300]}`,
    display: 'flex',
    flexDirection: 'column'
  },
  adminRoot: { opacity: '50%' },
  main: { padding: theme.spacing(2) },
  top: {
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.grey[300]}`
  },
  bottomm: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column'
  },
  grey: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    padding: theme.spacing(1),
    background: theme.palette.grey[200],
    borderRadius: 6,
    marginTop: 8,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr 1fr'
    }
  },
  card: {
    display: 'flex',
    borderRadius: 8,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    border: `1px solid ${theme.palette.grey[300]}`
  },
  image: {
    width: 191,
    height: 137,
    [theme.breakpoints.down('sm')]: {
      width: 100,
      height: 80
    },
    borderRadius: '8px 0  0 8px',
    objectFit: 'cover'
  },
  content: {
    display: 'grid',
    gridTemplateColumns: '3fr 1.5fr',
    width: '100%',
    height: 137,
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      height: 80,
      gridTemplateColumns: '1fr'
    }
  },
  left: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  textColor: {
    fontWeight: 600,
    color: theme.palette.grey[600],
    display: 'flex',
    verticalAlign: 'middle',

    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
      marginTop: 8
    }
  },
  header: { display: 'flex', flexDirection: 'column', flex: 3 },
  payment: { display: 'flex', flexDirection: 'column', flex: 1 },
  title: {
    fontSize: 20,
    fontWeight: 600,
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    }
  },
  location: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5)
  },
  paymentChip: {
    marginTop: theme.spacing(1),
    padding: 2,
    background: theme.palette.grey[200],
    width: 'fit-content',
    '& .MuiChip-label': {
      fontSize: 13,
      fontWeight: 500,
      color: theme.palette.grey[600]
    }
  },
  right: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end'
  },
  dateLabel: {
    color: theme.palette.grey[600],
    marginRight: 6,
    fontWeight: 600
  },
  dateValue: {
    fontWeight: 500,
    color: theme.palette.text.primary
  },
  stars: {
    display: 'flex',
    color: '#fbc02d',
    height: '60%',
    alignItems: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      marginTop: 8
    }
  },
  bottom: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(0.5),
    height: '40%',
    alignItems: 'flex-end',
    justifyContent: 'end',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start'
    }
  },
  check: { display: 'flex', flexDirection: 'row', marginTop: 4 },
  icon: {
    fontSize: 18,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    }
  },
  blackText: {
    fontWeight: 500,
    fontSize: 13,
    color: theme.palette.text.primary
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: theme.spacing(1),
    gap: 8,
    borderLeft: `2px solid ${theme.palette.grey[400]}`,
    [theme.breakpoints.down('sm')]: {
      marginTop: 8
    }
  },
  greyTex: { fontWeight: 500, fontSize: 13, color: theme.palette.grey[600] },
  details: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  }
}))
export default useStyles
